<template>
  <v-app>
    <AppHeader @containerFluid="setContainerFluid" :toggleStatus="containerFluid"></AppHeader>

    <template v-if="loggedIn">
      <AppSideNav></AppSideNav>
    </template>

    <v-main v-if="loggedIn" class="align-center" style="min-height: 400px;">
      <v-container :fluid="containerFluid">
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-main v-else>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <AppFooter></AppFooter>
  </v-app>
</template>

<script>
import {useAuthStore} from "@/components/store/userAuth.js";
import AppHeader from "@/components/layout/AppHeader.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import {computed} from "vue";
import { defineAsyncComponent } from 'vue';

export default {
  name: 'App',
  data: () => ({
    authStore: null,
    loggedIn: false,
    containerFluid: false,
  }),
  components: {
    AppHeader,
    AppFooter,
    AppSideNav: defineAsyncComponent(() =>
      import('@/components/layout/AppSideNav.vue')
    )
  },
  mounted() {
      this.authStore = useAuthStore()
      this.authStore.init();
      this.loggedIn = computed(() => this.authStore.isAuthenticated);
  },
  computed: {},
  methods: {
    setContainerFluid() {
      this.containerFluid = !this.containerFluid
      //console.log(this.containerFluid)
    }
  }
}
</script>

<style scoped>

</style>
